// extracted by mini-css-extract-plugin
export default {"Panels":"jaWakwTlr083IlabBh3w","Panel--inactive":"gtro7ZD8xMPr5ZbrapYm"};